import { MdPause, MdSecurity } from "react-icons/md";
import { VscHistory } from "react-icons/vsc";

import { ComponentWithAs, IconProps } from "@chakra-ui/react";

import { TemplateIcon } from "@/components/shared/ReleaseIcons";

export const environmentSettingsMenuItems = [
  "Configurations",
  {
    label: "Environment Configuration",
    icon: TemplateIcon,
    slug: "configuration",
  },
  {
    label: "Environment Variables",
    icon: TemplateIcon,
    slug: "environment_variables",
  },
  { label: "History", icon: VscHistory as ComponentWithAs<"svg", IconProps>, slug: "configurations" },
  "Advanced",
  { label: "Pausing Schedule", icon: MdPause as ComponentWithAs<"svg", IconProps>, slug: "pausing_schedule" },
  { label: "Protection", icon: MdSecurity as ComponentWithAs<"svg", IconProps>, slug: "protection" },
] as const;

type ExtractSlug<T> = T extends { slug: infer S } ? S : never;
export type EnvironmentSettingsMenuItem = ExtractSlug<(typeof environmentSettingsMenuItems)[number]>;
